function fn(isManual: boolean): boolean {
    return isManual !== true;
}

export default fn;
